import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
interface CTASectionProps {
  title?: string;
  isMain?: boolean;
}
export function CTASection({
  title = 'Try Lumera Gen 2 Risk-Free',
  isMain = false
}: CTASectionProps) {
  return <div className={`my-12 p-8 md:p-10 rounded-sm text-center ${isMain ? 'bg-slate-900 text-white' : 'bg-[#F5F5F0] border border-gray-300 text-gray-900'}`} data-id="element-1">
      <h3 className={`text-2xl md:text-3xl font-serif font-bold mb-6 ${isMain ? 'text-white' : 'text-slate-900'}`} data-id="element-2">
        {title}
      </h3>

      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-8 text-sm md:text-base" data-id="element-3">
        <div className="flex items-center" data-id="element-4">
          <CheckIcon className={`h-5 w-5 mr-2 ${isMain ? 'text-green-400' : 'text-green-600'}`} data-id="element-5" />
          <span data-id="element-6">90-Day Satisfaction Guarantee</span>
        </div>
        <div className="flex items-center" data-id="element-7">
          <CheckIcon className={`h-5 w-5 mr-2 ${isMain ? 'text-green-400' : 'text-green-600'}`} data-id="element-8" />
          <span data-id="element-9">Local Support Team</span>
        </div>
        <div className="flex items-center" data-id="element-10">
          <CheckIcon className={`h-5 w-5 mr-2 ${isMain ? 'text-green-400' : 'text-green-600'}`} data-id="element-11" />
          <span data-id="element-12">Free Shipping</span>
        </div>
      </div>

      <a href="https://lumeraa.net/pages/lumera-massager-sale" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto px-8 py-4 bg-[#C0392B] hover:bg-[#A93226] text-white font-bold text-lg uppercase tracking-wide transition-colors shadow-lg flex items-center justify-center mx-auto group no-underline" data-id="element-13">
        Check Availability
        <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-14" />
      </a>

      <p className={`mt-4 text-xs ${isMain ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-15">
        Limited stock available due to high demand.
      </p>
    </div>;
}